import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import { ArrowButton } from 'components/arrow-button';
import { List } from 'components/list';
import { Box } from 'components/ui';
import { PageHeading } from 'pages/support-v2/support-form-v2.styled';
import { spacing } from 'styles/constants';

import noop from '../../../utils/noop';

import { ISupportV2CategoryViewProps } from './types';

export const SupportV2CategoryView: FC<React.PropsWithChildren<ISupportV2CategoryViewProps>> = ({
  pageTitle,
  subcategories,
  onSelectSubcategory = noop,
}) => (
  <Box style={styles.contentWrap}>
    <PageHeading aria-live="polite" testID="page-heading">
      {pageTitle}
    </PageHeading>

    <List style={styles.list} showsVerticalScrollIndicator={false}>
      {subcategories.map(item => (
        <ArrowButton onPress={() => onSelectSubcategory(item)} key={item._id}>
          {item.name}
        </ArrowButton>
      ))}
    </List>
  </Box>
);

const styles = StyleSheet.create({
  contentWrap: {
    marginTop: spacing.$8,
    marginBottom: 0,
  },
  list: {
    marginHorizontal: spacing.$6,
  },
});
